export default "__VITE_ASSET__G6LGXzjF__"